import {PersonalCustomsClearanceState} from '../interfaces'

export const getInitialState = (): PersonalCustomsClearanceState => ({
    agreedWithCollection: false,
    code: '',
    existingCode: '',
    uses: 'Y',
    isOverseasDelivery: false,
    customType: null,
    scene: 'edit',
    screenScene: 'IDLE',
    customsCode: {
        view: '',
        hash: '',
    },
    saved: {
        view: '',
        hash: '',
        name: '',
        phone: '',
    },
    selected: {
        id: '',
        view: '',
        hash: '',
        name: '',
        phone: '',
    },
})
